import logo from 'assets/images/logos/voltus.png'

const isDev = !window.location.href.includes('app.gogriddy')

const base = '#00263A' // '#022135'
const primary = '#84BD00' // '#84BD00'
const secondary = '#00A9E0' // '#00A9E0'
const blue = '#00BCD4'
const gray = '#d5dee5'
const grayMedium = '#7D8D9E'
const grey = '#999999'
const green = '#7CA51B'
const greenPromo = '#8FAB36'
const error = '#dd2c00'
const neutral1 = '#022135'
const neutral2 = '#7D8D9E'
const neutral3 = '#9DB1C6'
const neutral4 = '#D5DEE5'
const neutral5 = '#F2F3F6'
const white = '#fff'
const footerColor = '#00263A'
const darkerPrimary = '#648d04' // used for hover effect

export const color = {
  background: '#f2f3f6',
  base,
  primary,
  secondary,
  blue,
  gray,
  grayMedium,
  grey,
  green,
  greenPromo,
  error,
  gradient: white,
  link: primary,
  neutral1,
  neutral2,
  neutral3,
  neutral4,
  neutral5,
  white,
  footerColor,
  darkerPrimary,
  buttonColor: '#fff',
  buttonColorSecondary: '#fff',
  buttonBorder: primary,
  buttonBackground: '#fff',
  costColors: {
    first: '#f38762',
    second: '#f7935c',
    third: '#6b497e',
    fourth: '#333e6b',
  },
  usageGraph: {
    isPending: '#9CE6EC',
    isNotPending: '#00BCD4',
    gradientStart: '#10C1D7',
    gradientEnd: '#098797',
    base: '#00BCD4',
  },
  ratePanel: secondary,
  rateText: primary,
  offerDetails: neutral3,
  offerShortDescription: neutral2,
  renewalBanner: {
    text: 'white',
    background: primary,
  },
}

export const companyInfo = {
  portalName: 'MyVoltus',
  fullName: 'Volta',
  shortName: 'Volta',
  email: 'care@voltus.com',
  phone: '(888) 925-1061',
  text_number: '(281)-688-6793',
  hoursOfOperation: '(Mon - Fri 8am - 5pm CST)',
  signUpLink: 'https://development.d14ckre8fkh22s.amplifyapp.com/',
  defaultTimeZone: 'US/Central',
  homepageLink: 'https://www.voltus.co/',
  mixpanelToken: '',
  allowMakePaymentEnterNewCard: true,
}

export const logoConfig = {
  localPath: 'assets/images/logos/voltus.png',
  url: '',
  width: 'auto',
  height: '45px',
  useLocal: true,
  imgType: 'png',
  logo,
  wrapper: {
    padding: 10,
    backgroundColor: 'transparent',
  },
}

const baseFamily = "'Helvetica Neue', Helvetica, Arial, sans-serif"
const customFont = 'MADE Evolve Sans'

export const font = {
  extraBold: '800',
  semiBold: '600',
  medium: '500',
  normal: '400',
  baseFamily,
  customFont,
  customFamily: `${customFont}, ${baseFamily}`,
}

export const fontFace = `
@font-face {
    font-family: ${font.customFont};
    src: url('/fonts/made-evolve-sans/MADE-Evolve-Sans-Regular.woff') format('woff');
    font-weight: ${font.normal};
    font-style: normal;
  }

  @font-face {
    font-family: ${font.customFont};
    src: url('/fonts/made-evolve-sans/MADE-Evolve-Sans-Medium.woff') format('woff');
    font-weight: ${font.medium};
    font-style: normal;
  }

  @font-face {
    font-family: ${font.customFont};
    src: url('/fonts/made-evolve-sans/MADE-Evolve-Sans-Bold.woff') format('woff');
    font-weight: ${font.semiBold};
    font-style: normal;
  }

  @font-face {
    font-family: ${font.customFont};
    src: url('/fonts/made-evolve-sans/MADE-Evolve-Sans-Bold.woff') format('woff');
    font-weight: ${font.extraBold};
    font-style: normal;
  }
`

export const routes = {
  homePagePath: '/account',
  wholesale: false,
  devices: false,
}

export const features = {
  ADD_FUNDS_PAST_DUE_BALANCE: false,
  ADD_FUNDS_CURRENT_BALANCE: false,
  ADD_FUNDS_LAST_BILL_AMOUNT: true,
  ADD_FUNDS_BALANCE_DUE: true,
  ACCOUNT_BALANCE_DUE: true,
  ACCOUNT_PAST_DUE_BALANCE: false,
  ACCOUNT_CURRENT_BALANCE: false,
  CURRENT_BALANCE_BANNER: false,
  REFER_A_FRIEND: false,
  RECHARGE_AMOUNT: false,
  ADD_METER: false,
  REACT_APP_ZENDESK_CHAT_ENABLE:
    process.env.REACT_APP_ZENDESK_CHAT_ENABLE === 'true' ? true : false,
  RENEWAL_BANNER: false,
  PLUS_BANNER: false,
  SHOW_SIGN_UP_LINK: true,
  DISABLE_BILLING_TOGGLES: false,
}

export const url = {
  SIGN_UP: isDev
    ? 'https://config.d3fbicgal063f7.amplifyapp.com'
    : 'https://enroll.abacus-energy.com',
  ZENDESK_SECTIONS:
    'api/v2/help_center/en-us/categories/4412571127575-Abacus-Energy/sections.json',
}

export const graphs = {
  usage_kwh: true,
  price_ckwh: false,
  cost_dollars: true,
}
